import Swiper from 'swiper';
require('../customer/components/storefinder');
import './widgets/stofstaal-selection';


import { api } from '@cloudsuite/theme_library/scripts/helper';

const closePhotoSwipe = event => {
    $('.sticky-parent').removeClass('not-sticky');
}

const calcSlidesPerView = (container, peek = 0) => {
    const estimatedWidth = 300;
    const containerWidth = $(container).outerWidth();
    return Math.floor(containerWidth / estimatedWidth) + peek;
};

const promotionWidget = $('.js-promotions-widget');
let promotionSliders = [];

promotionWidget.each(function (index, element) {
    const halfContainer = $(this).parents().hasClass('col-md-6');
    const slidesPerView = calcSlidesPerView($($(this)).parent(), halfContainer ? .5 : .3);
    $(this).addClass('s' + index);
    let next_slider = 'slider-next' + index;
    let prev_slider = 'slider-prev' + index;
    $(this).parent().find(".promotion-nav-next").addClass(next_slider);
    $(this).parent().find(".promotion-nav-prev").addClass(prev_slider);
    let slider = new Swiper('.s' + index, {
        passiveListeners: false,
        observer: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        watchSlidesProgress: true,
        longSwipes: false,
        spaceBetween: 30,
        direction: "horizontal",
        watchOverflow: true,
        navigation: {
            nextEl: ('.' + next_slider),
            prevEl: ('.' + prev_slider),
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize: 'auto'
        },
        pagination: {
            clickable: true,
            el: ".slider-pagination"
        },
        mousewheel: {
            forceToAxis: true,
            invert: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            640: {
                slidesPerView: slidesPerView,
                spaceBetween: 20
            },
            768: {
                slidesPerView: 3.5,
                spaceBetween: 20
            },
            992: {
                slidesPerView: 5,
                spaceBetween: 25
            },
            1200: {
                slidesPerView: 5.5,
                spaceBetween: 25
            },
            1400: {
                slidesPerView: 6,
                spaceBetween: 25
            }
        },
        // on: {
        //     resize: function () {
        //         this.updateSlides();
        //     }
        // }
    });
    promotionSliders.push(slider);
    
});

function openPhotoSwipe(index = null) {
    if (index == null)
        index = $('.js-product-image-slider').find('.swiper-slide-active').index();

    const element = document.querySelectorAll('.pswp')[0];
    const items = [];
    const options = {   
        timeToIdle: 4000,
        index: index,
        shareButtons: [
            {
                id: 'facebook',
                label: js_translations['carousel_share-fb'],
                url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}'
            },
            {
                id: 'twitter',
                label: js_translations['carousel_share-tw'],
                url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'
            },
            {
                id: 'pinterest',
                label: js_translations['carousel_share-pi'],
                url: 'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}'
            },
            {
                id: 'download', 
                label: js_translations['carousel_share-down'], 
                url: '{{raw_image_url}}', 
                download: true
            }
        ],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        tapToToggleControls: false,
    };

    const images = $('.trigger-photoswipe');

    images.each((index, img) => {
        items.push({src: $(img).attr('data-powerswipe'), w: 1000, h: 600});
    });

    var pswpContainer = document.querySelector('.pswp__container');

    pswpContainer.addEventListener('click', function(e) {
        if (!pswpContainer.isTouch) {
        e.preventDefault();
        e.stopPropagation();

        var zoomLevel = gallery.getZoomLevel();
        var zoomTarget = zoomLevel === gallery.currItem.initialZoomLevel ? 3 : gallery.currItem.initialZoomLevel;

        gallery.zoomTo(zoomTarget, { x: e.clientX, y: e.clientY }, 300);
        }
    });

    var gallery = new PhotoSwipe(element, PhotoSwipeUI_Default, items, options);
    gallery.init();
}

$('.pswp__button--close').on('click', closePhotoSwipe)

$(document).on('click', '.trigger-photoswipe', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    $('.sticky-parent').addClass('not-sticky');
    openPhotoSwipe($(this).data('index') || $('.js-product-image-slider').find('.swiper-slide-active').index());
});

$(document).on('click', '.js-open-slider-zoom', function () {
    $('.js-product-image-slider').find('.swiper-slide-active img').trigger('click');
});

const hotspotWrapper = $('.img-hotspot-wrapper');
if (hotspotWrapper.length) {
    const targets = hotspotWrapper.find('.hotspot-target'),
        image = hotspotWrapper.find('.hotspot-img');

    // unbind hoverintent & other eventlisteners
    targets.unbind('mouseenter').unbind('mouseleave');
    targets.removeProp('hoverIntent_t');
    targets.removeProp('hoverIntent_s');
    hotspotWrapper.off();

    const config = {
        showLoggedOutNotification: true,
        showLoggedInNoglobaltification: true,
        customerUsesMultipleLanguages: true,
        language: $('#enterpriseDomain').val().split('_')[0]
    };

    const global = {
        wishlistName: (config.customerUsesMultipleLanguages ? `cs_wishlist_${config.language}` : 'cs_wishlist'),
        enterpriseDomain: (config.customerUsesMultipleLanguages ? document.getElementById('enterpriseDomain').value : ''),
    }

    let productList = [];

    // bind new click events
    targets.on('click', async function(e) {
        e.stopPropagation();
        // fill hotspot with product data
        let hotspot = $(this).parent(),
            hotspot_data = hotspot.data('product'),
            modal = $('#js-hotspot-modal-'+hotspot.attr('id')),
            name = hotspot.data('name'),
            desc = hotspot.data('desc'),
            reviews = hotspot.data('reviews'),
            image = hotspot.data('img'),
            wishlist_url = hotspot.data('wishlist-url'),
            wishlist_cookie_data = JSON.stringify(hotspot.data('product')),
            price = hotspot.data('price'),
            salesprice = hotspot.data('salesprice'),
            url = hotspot.data('url'),
            reviews_elm = modal.find('.product-review'),
            price_elm = modal.find('.price-standard'),
            salesprice_elm = modal.find('.price-sales'),
            wishlist_cookie_elm = modal.find('[data-js-hotspot-wishlist]'),
            wishlist_elm = modal.find('.js-wishlist-add'),
            strip_desc = $.parseHTML(desc);

            

        const formatPrice = function(e) {
            return parseFloat(e).toFixed(2);
        };

        // Discount price
        const original_price = hotspot_data.sale_price_no_format,
            priceConsumer = hotspot_data.consumer_price_no_format !== null ? hotspot_data.consumer_price_no_format : hotspot_data.sale_price_no_format,
            salePrice = original_price !== priceConsumer,
            discountCalculation = (original_price - priceConsumer) / priceConsumer * 100,
            discount = Math.round(discountCalculation);

        if (salePrice ) {
        modal.find('[data-js-hotspot="discount-label"]').text(`${discount}%`);
        modal.find('[data-js-hotspot="discount-label"]').removeClass('hidden');
        modal.find('.price-sales').css('font-weight', 'bold');
        }

        modal.find('.section-title').text(name);
        modal.find('.desc').html(desc);
        modal.find('img').attr('src', image).attr('alt', name);
        modal.find('.btn.larger').attr('href', url);

        productList = JSON.parse(localStorage.getItem(global.wishlistName));
        productList.products.forEach(wlproduct => {             
            if (JSON.parse(wishlist_cookie_data).id == wlproduct.id) {
                modal.find('.listview-heart').addClass('fas');
                modal.find('.listview-heart').removeClass('far');
             }
        });
      
        hotspot_data.tags.forEach(tag => {   
            if (tag.description && tag.description !=='' && tag.picture === 'HTML') {
                modal.find('[data-js-hotspot="tag"]').html(tag.description);
            }
        });

        if (price_elm.length && salesprice != price) {
            price_elm.text(price);
        } else {
            price_elm.text('');
        }
        if (salesprice_elm.length) {
            salesprice_elm.text(salesprice);
        }
        if (reviews.length) {
            reviews_elm.html(reviews);
        }
        if (wishlist_cookie_elm.length) {
            wishlist_cookie_elm.attr('data-product', wishlist_cookie_data);
            wishlist_cookie_elm.attr('data-id', JSON.parse(wishlist_cookie_data).id);
        }
        if (wishlist_elm.length) {
            wishlist_elm.attr('data-url', wishlist_url);
        }

        // retrieve categories
        const request = await api.get(hotspot.data("tree-parents-url").replace('999999', hotspot_data.tree_id))
        .then((trees) => {
            return trees.map(tree => tree.name).join('/');
        });

        //Datalayer 
        const gtm_data = () => {
            return {
                'location': window.location.href,
                'delivery_text': modal.find("[data-js-ga-delivery-days] p").text().trim(),
                'delivery_days': modal.find("[data-js-ga-delivery-days]").attr('data-js-ga-dd'),
                'ecommerce': {
                    'details': {
                        'products': [
                            {
                                'name': name,
                                'id': hotspot_data.code,
                                'price': formatPrice(hotspot_data.sale_price_no_format),
                                'brand': hotspot_data.brand,
                                'category': `${request}/${hotspot_data.tree_name}`,
                                'variant': hotspot_data.variant_name
                            }
                        ]
                    }
                }
            }
        }

        dataLayer.push({
            'event': 'hotspot',
            ...gtm_data()
        });

        $(document).off('click', '.js-hotspot-modal')
        $(document).on('click', '.js-hotspot-modal', function(e){
            if ($(e.target).is('[data-js-hotspot-wishlist]')) {
                if ($(e.target).find('.listview-heart ').is('.far.wl_loggedout') || $(e.target).find('.listview-heart').is('.far.wl_loggedin') ) {
                    dataLayer.push({
                        'event': 'hotspot_wishlist',
                        ...gtm_data()
                    });
                }
            }

            if ($(e.target).is('[data-js-hotspot="continue-button"]')) {
                dataLayer.push({
                    'event': 'hotspot_btn_bekijk',
                    ...gtm_data()
                });
            }
        });

        // Open modal
        if (hotspot.parents().hasClass('carousel--hotspot')) {
            const modalChildNodes = modal.html();
            $('#js-carousel-hotspot-modal').html(modalChildNodes);
            $('#js-carousel-hotspot-modal').modal('show');
            if (window.innerWidth > 767) {
                $('body').css('overflow', 'unset');
            }
            
        } else {
            modal.modal('show');
        }
    });
}

const JS_CALENDAR = $('.js-calendar');

JS_CALENDAR.each(function () {
    $(this).datepicker({minDate: 2})
});

let date = JS_CALENDAR.datepicker('getDate');

JS_CALENDAR.on('change', function () {
    let tempDate = $('.js-calendar').datepicker('getDate'),
        month = tempDate.getUTCMonth() + 1,
        day = tempDate.getUTCDate() + 1,
        year = tempDate.getUTCFullYear();

    date = `${day}-${month}-${year}`;
    $('#js-calendar-value').val(date);
})

$('.js-countdown').each(function () {
    const $this = $(this), finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function (event) {
        $this.html(event.strftime('%D : %H : %M : %S'));
    });
});

const reviewSlider = new Swiper('.js-product-review-carousel', {
    slidesPerView: 'auto',
    passiveListeners: false,
    centeredSlides: false,
    freeMode: true,
    freeModeSticky: true,
    spaceBetween: 20,
    direction: "horizontal",
    slidesPerView: 1.75,
    mousewheel: {
        forceToAxis: true
    },
    navigation: {
        nextEl: '#review-nav-next',
        prevEl: '#review-nav-prev',
    },
    breakpoints: {
        320: {
            spaceBetween: 10
        },
        640: {
            spaceBetween: 20
        },
        992: {
            spaceBetween: 30
        },
        1200: {
            slidesPerView: 2.5,
            spaceBetween: 30
        }
    },
    on: {
        resize: function () {
            this.updateSlides();
        }
    }
});

let MORE_REVIEWS_LOADING_OVERLAY = document.querySelector('.more-reviews-overlay');
let SHOW_MORE_REVIEWS_BTN_WRAPPER = document.getElementById('review-nav-next');
let SHOW_MORE_REVIEWS_BTN = document.querySelector('.show-more-reviews');

if (SHOW_MORE_REVIEWS_BTN && reviewSlider.slides.length > 9) {
    reviewSlider.on('fromEdge', function () {
        reviewSlider.el.classList.remove('onEdge');
        SHOW_MORE_REVIEWS_BTN_WRAPPER.classList.remove('onEdge');
        reviewSlider.el.classList.remove('theEnd');
        SHOW_MORE_REVIEWS_BTN.classList.add('hidden');
    })

    reviewSlider.on('reachEnd', function () {
        reviewSlider.el.classList.add('onEdge');
        SHOW_MORE_REVIEWS_BTN_WRAPPER.classList.add('onEdge');
        SHOW_MORE_REVIEWS_BTN.classList.remove('hidden');
    });

    const CURRENT_URL = new URL(SHOW_MORE_REVIEWS_BTN.dataset.url);
    let CURRENT_PAGE = ~~CURRENT_URL.searchParams.get('page');

    const total = ~~SHOW_MORE_REVIEWS_BTN.dataset.totalReviews;

    SHOW_MORE_REVIEWS_BTN.addEventListener('click', async function () {
        let finalData = null;
        MORE_REVIEWS_LOADING_OVERLAY.classList.remove('hidden');

        const request = fetch(CURRENT_URL.href);
        await request.then(async data => {
            finalData = await data.text();
        });

        $(document.body).append($.parseHTML(finalData));

        const PRODUCT_REVIEWS = document.querySelector(`#product-reviews-page-${CURRENT_PAGE}`);

        $(PRODUCT_REVIEWS).find('.swiper-slide').each((index, child) => {
            reviewSlider.appendSlide(child);
        })

        reviewSlider.update();
        MORE_REVIEWS_LOADING_OVERLAY.classList.add('hidden');
        reviewSlider.slideTo(reviewSlider.realIndex + 1);
        PRODUCT_REVIEWS.remove();

        if (total <= (CURRENT_PAGE * 10)) {
            SHOW_MORE_REVIEWS_BTN.remove();

            reviewSlider.on('reachEnd', function () {
                reviewSlider.el.classList.add('theEnd');
            });
        }

        CURRENT_PAGE++;
        CURRENT_URL.searchParams.set('page', `${CURRENT_PAGE}`);
    });
} else {
    reviewSlider.on('reachEnd', function () {
        reviewSlider.el.classList.add('theEnd');
    });

    reviewSlider.on('fromEdge', function () {
        reviewSlider.el.classList.remove('theEnd');
    })
}

$('.deliverymethods-slider').slick({
    mobileFirst: true,
    arrows: false,
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 992,
            settings: "unslick"
        },
    ]
});

if ($('.js-advice-slick').length) {
    $('.js-advice-slick').slick({
        mobileFirst: true,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1179,
                settings: "unslick"
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.5,
                }
            },
        ]
    });
}

$(window).bind("load", function () {
    var slideContainer2 = $('.js-advice-slick'),
        slickTrack2 = $('.js-advice-slick .slick-track'),
        slides2 = $('.slick-slide');

    slideContainer2.find(slides2).find('div:first').css('height', slickTrack2.height() + 'px');

    var slideContainer = $('.deliverymethods-slider'),
        slickTrack = $('.deliverymethods-slider .slick-track'),
        slides = $('.slick-slide');

    slideContainer.find(slides).find('div:first').css('height', slickTrack.height() + 'px');
});

const customFilters = document.querySelectorAll('[data-js-filter-swiper]');

if (customFilters.length) {
    customFilters.forEach(filter => {   
        const itemSpacing = filter.getAttribute('data-item-spacing');

        const filterSwiper = new Swiper(filter, {
            slidesPerView: 'auto',
            watchOverflow: true,
            spaceBetween: itemSpacing ? parseInt(itemSpacing) : 5,
            navigation: {
                nextEl: filter.parentNode.querySelector('[data-js-filter-swiper-next]'),
                prevEl: filter.parentNode.querySelector('[data-js-filter-swiper-prev]'),
            },
            on: {
                lock() {
                    this.el.style.width = '100%';
                    this.el.parentNode.parentNode.style.width = 'fit-content';
                }
            }
        });
    });
}

require("../customer/components/storefinder");